module.exports = __webpack_public_path__ + "img/menu_list_icon.4c2490d5.png";